import { useState } from "react";
import { formatCurrency } from "@/components/Layout";
import { Wallet } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export const StartingBalanceInput = ({ value, onChange, currency }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value.toString());
  
  const handleSave = () => {
    const numValue = parseFloat(inputValue) || 0;
    onChange(numValue);
    setIsEditing(false);
  };
  
  const currencySymbol = currency === 'USD' ? '$' : currency === 'EUR' ? '€' : '£';
  
  if (isEditing) {
    return (
      <div className="flex items-center gap-2 mb-4 p-3 rounded-xl bg-white border border-p2p-teal/50 shadow-sm">
        <Wallet className="w-5 h-5 text-p2p-teal" />
        <span className="text-sm text-p2p-muted">Current balance:</span>
        <div className="relative flex-1 max-w-[120px]">
          <span className="absolute left-2 top-1/2 -translate-y-1/2 text-p2p-muted">{currencySymbol}</span>
          <Input
            type="number"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onBlur={handleSave}
            onKeyDown={(e) => e.key === 'Enter' && handleSave()}
            className="h-8 pl-6 text-sm font-mono border-p2p-border rounded-lg"
            autoFocus
            data-testid="starting-balance-input"
          />
        </div>
        <Button size="sm" onClick={handleSave} className="h-8 px-3 bg-p2p-teal text-white">
          Save
        </Button>
      </div>
    );
  }
  
  return (
    <button
      onClick={() => setIsEditing(true)}
      className="flex items-center gap-2 mb-4 px-4 py-2.5 rounded-xl bg-white/80 border border-p2p-border/50 hover:border-p2p-teal/50 hover:bg-white transition-all text-left w-full sm:w-auto"
      data-testid="starting-balance-btn"
    >
      <Wallet className="w-4 h-4 text-p2p-muted" />
      <span className="text-sm text-p2p-muted">Starting with:</span>
      <span className="font-mono font-semibold text-p2p-teal">
        {formatCurrency(value, currency)}
      </span>
      <span className="text-xs text-p2p-muted ml-1">(tap to change)</span>
    </button>
  );
};

export default StartingBalanceInput;
